import Event from './Event';
import LocalStorage from '../local_data';

class SetSocialAuth extends Event {
    eventName = 'oms_setSocialAuth';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for set social login
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let auth = JSON.parse(data.auth);
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        
        if (clientId) {
            let response = {
                authType: "public",
                client_id: clientId,
                data: auth,
                logout: !auth.success
            };

            let formarData = this.formatResponseData(response);

            if (auth.success) {
                //set auth requesting variable to null - so new access token value can be retriveved from promise
                window.ajaxAuthRequest = null;
    
                let userDetails = new LocalStorage.UserDetails(clientId);
                userDetails.setData(response);
            }
    
            // delete social cookie
            this.deleteCookie('social_auth_customer');

            this.onSuccessEvent({
                "auth_type": "public",//? 
                "data": formarData,
                "data_type": "local", //
                "success" : true,//
                "message" : ""//
            }, {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }

    deleteCookie(name, path) {
        var domain = window.location.origin;
        domain = domain.split('.');
        var domainArray = [];
        domainArray.push(domain.pop());
        domainArray.push(domain.pop());
        domain = domainArray[1] + '.' + domainArray[0];

        if (this.getCookie(name)) {
          document.cookie = name + "=" +
            ((path) ? ";path="+path:"")+
            ((domain)?";domain="+domain:"") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    }

    getCookie(name) {
        return document.cookie.split(';').some(c => {
            return c.trim().startsWith(name + '=');
        });
    }
}

export default SetSocialAuth;